<template>
  <div class="facial-harmonization-container">
    <div class="content-section">
      <h2 class="pb-2 border-bottom">Armonización Facial</h2>
      <p>Equilibrio, Simetría y Resultados Naturales</p>
      <p>
        Nuestros tratamientos de armonización facial están diseñados para crear
        equilibrio y belleza natural mediante técnicas mínimamente invasivas. En
        lugar de enfocarnos en un solo rasgo, adoptamos un enfoque holístico,
        que realza la armonía general y la autoconfianza.
      </p>
      <h3>Tratamientos principales</h3>
      <ul>
        <li>
          Neuromoduladores — suavizan expresiones para un aspecto renovado.
        </li>
        <li>
          Rellenos dérmicos — restauran volumen y contorno en mejillas, labios y
          mandíbula.
        </li>
        <li>
          Definición de mentón & mandíbula — mejora proporciones y estructura
          facial.
        </li>
        <li>
          Realce labial — resultados sutiles o voluminosos, siempre
          personalizados.
        </li>
        <li>
          Rinoplastia no quirúrgica — refinamiento nasal con técnicas precisas
          de relleno.
        </li>
        <li>Soporte para ojeras & sienes — devuelve volumen y suavidad.</li>
        <li>
          Lifting de pómulos — realce natural de la zona media del rostro.
        </li>
        <li>
          Skin boosters (PRP, bioestimuladores) — mejoran hidratación y calidad
          de la piel.
        </li>
        <li>Hilos de PDO (opcional) — efecto lifting sin cirugía invasiva.</li>
      </ul>
      <h3>Resumen del procedimiento</h3>
      <ul>
        <li>
          Consulta & análisis facial — evaluación personalizada y planificación.
        </li>
        <li>
          Procedimiento — técnicas seguras con anestesia local o crema
          anestésica.
        </li>
        <li>
          Resultados inmediatos — mejoras naturales con poco o ningún downtime.
        </li>
        <li>
          Seguimiento & cuidados — indicaciones para confort y resultados
          duraderos.
        </li>
      </ul>
      <p>
        "La armonización facial no consiste en cambiar quién eres — sino en
        resaltar tu belleza natural con equilibrio, confianza y refinamiento
        sutil."
      </p>
    </div>
    <div class="fh-videos">
      <iframe
        width="320"
        height="568"
        style="
          max-width: 100%;
          border-radius: 12px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
          margin-bottom: 1.5rem;
        "
        src="https://www.youtube.com/embed/dsy8tUMNyIs"
        title="YouTube Shorts: Facial Harmonization 1"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
      <iframe
        width="320"
        height="568"
        style="
          max-width: 100%;
          border-radius: 12px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
        "
        src="https://www.youtube.com/embed/LM2IEIQ-mC8"
        title="YouTube Shorts: Facial Harmonization 2"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "FacialHarmonizationContentEs",
};
</script>

<style scoped>
.facial-harmonization-container {
  display: flex;
  gap: 2rem;
  align-items: flex-start;
}

.content-section {
  flex: 1;
  min-width: 0;
}

.fh-videos {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.fh-videos iframe {
  width: 320px;
  height: 568px;
  max-width: 100%;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

/* Responsive design */
@media (max-width: 768px) {
  .facial-harmonization-container {
    flex-direction: column;
    gap: 1.5rem;
  }

  .fh-videos {
    align-self: center;
  }

  .fh-videos iframe {
    width: 280px;
    height: 497px;
  }
}

@media (max-width: 480px) {
  .fh-videos iframe {
    width: 240px;
    height: 426px;
  }
}
</style>
